import { LoanCaseDTO, ProductInstanceDTO } from "@smartx/mikro-vt-client-api"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useValueLists } from "../app/hooks"
import { productCodes } from "../functions/caseHelper"
import { isBiancoCase, isPalCase } from "../functions/helpers"
import { VALUE_LIST_ENUM } from "../functions/setCodeTableValues"

const getProductCodeForFieldName = (product: ProductInstanceDTO): string => {
  const biancoProductType = product?.biancoProductType
  const productCode = product?.productCode

  if (biancoProductType === "EGYEB") {
    return null
  }

  if (
    [productCodes.SZKEH, productCodes.BSZKEH].includes(productCode) ||
    biancoProductType === "EH"
  ) {
    return "EH"
  }

  if (
    [productCodes.SZKFH, productCodes.ASZKFH, productCodes.PALFH].includes(
      productCode,
    ) ||
    biancoProductType === "FH"
  ) {
    return "FH"
  }

  return productCode
}

export const useProductFieldLabelUtil = () => {
  const { t } = useTranslation()
  const cvts = useValueLists()

  const productFieldLabelUtil = useMemo(() => {
    return (product: ProductInstanceDTO, field: string) => {
      const productCode = getProductCodeForFieldName(product)

      if (!productCode) {
        return t(`case.fields.productInstance.${field}`)
      }

      return (
        t(`case.fields.productInstance.${productCode}`) +
        t(`case.fields.productInstance.${field}`).toLowerCase()
      )
    }
  }, [t])

  const productNameUtil = useMemo(() => {
    return (loanCase: LoanCaseDTO) => {
      if (isPalCase(loanCase) || isBiancoCase(loanCase)) {
        return loanCase.productInstances?.find((el) => !!el)?.subProductName
      }

      return (
        cvts
          .find((cvt) => cvt.valueListCode === VALUE_LIST_ENUM.ProductList)
          ?.values?.find((val) => val.code === loanCase.productCode)?.value ??
        loanCase.productCode
      )
    }
  }, [cvts])

  return {
    productFieldLabelUtil,
    productNameUtil,
  }
}
